module.exports = __webpack_public_path__ + "static/media/dot-not-selected.e855c8a6.svg";